<template>
  <main class="index-page">
    <PageHeader />
    <div class="stats-grid">
      <el-card shadow="never">
        <span>Key 数量</span>
        <strong>{{ keys.length }}</strong>
      </el-card>
      <el-card shadow="never">
        <span>总额度</span>
        <strong>{{ totalQuota }}</strong>
      </el-card>
      <el-card shadow="never">
        <span>已使用</span>
        <strong>{{ totalUsed }}</strong>
      </el-card>
    </div>
    <EndpointSection :endpoint="endpoint" />
    <CreateKeySection
      :loading="creating"
      :notice="notice"
      @create="handleCreate"
    />
    <el-card class="panel-card" shadow="never">
      <div class="card-header">
        <span>过期 Key 清理</span>
        <el-button type="danger" plain :loading="cleaningExpired" @click="handleDeleteExpired">
          清除过期 Key
        </el-button>
      </div>
    </el-card>
    <KeyTable
      :keys="keys"
      :loading="loading"
      @update="handleUpdate"
      @delete="handleDelete"
    />
  </main>
</template>

<script>
import { createKey, deleteExpiredKeys, deleteKey, fetchKeys, updateKey } from '@/api/keys'
import PageHeader from './components/PageHeader.vue'
import EndpointSection from './components/EndpointSection.vue'
import CreateKeySection from './components/CreateKeySection.vue'
import KeyTable from './components/KeyTable.vue'
import './index.css'

export default {
  name: 'IndexView',
  components: {
    PageHeader,
    EndpointSection,
    CreateKeySection,
    KeyTable
  },
  data() {
    return {
      keys: [],
      loading: false,
      creating: false,
      cleaningExpired: false,
      notice: '',
      endpoint: ''
    }
  },
  computed: {
    totalQuota() {
      return this.keys.reduce((sum, item) => sum + Number(item.quota || 0), 0)
    },
    totalUsed() {
      return this.keys.reduce((sum, item) => sum + Number(item.used || 0), 0)
    }
  },
  mounted() {
    this.endpoint = `${window.location.origin}/v1/chat/completions`
    this.loadKeys()
  },
  methods: {
    async loadKeys() {
      this.loading = true
      try {
        this.keys = await fetchKeys()
      } catch (error) {
        this.notice = error.message
      } finally {
        this.loading = false
      }
    },
    async handleCreate(payload) {
      this.creating = true
      this.notice = ''
      try {
        const data = await createKey({
          quota: Number(payload?.quota || 100),
          expires_at: payload?.expires_at
        })
        this.notice = data.key ? `已生成：${data.key}` : JSON.stringify(data)
        await this.loadKeys()
      } catch (error) {
        this.notice = error.message
      } finally {
        this.creating = false
      }
    },
    async handleUpdate(item) {
      this.notice = ''
      const payload = {
        quota: Number(item.quota || 0),
        used: Number(item.used || 0),
        status: Number(item.status),
        expires_at: item.expires_at || item.expires_at_text
      }
      console.log('[IndexView] update api key payload', {
        id: item.id,
        item,
        payload
      })
      try {
        await updateKey(item.id, payload)
        this.notice = 'Key 已更新'
        await this.loadKeys()
      } catch (error) {
        this.notice = error.message
      }
    },
    async handleDelete(item) {
      if (!window.confirm(`确认删除这个 Key 吗？\n${item.key}`)) {
        return
      }
      this.notice = ''
      try {
        await deleteKey(item.id)
        this.notice = 'Key 已删除'
        await this.loadKeys()
      } catch (error) {
        this.notice = error.message
      }
    },
    async handleDeleteExpired() {
      if (!window.confirm('确认清除所有已过期的 API Key 吗？')) {
        return
      }
      this.cleaningExpired = true
      this.notice = ''
      try {
        const data = await deleteExpiredKeys()
        this.notice = `已清除 ${data.deleted || 0} 个过期 Key`
        await this.loadKeys()
      } catch (error) {
        this.notice = error.message
      } finally {
        this.cleaningExpired = false
      }
    }
  }
}
</script>
